module.exports = __webpack_public_path__ + "img/safetyImg4.91e3173e.png";